import React from "react";
import RetailerWidgetSettings from "src/components/RetailerWidgetSettings";
import WidgetImageUploadForm from "src/components/RetailerWidgetSettings/WidgetImageUploadForm";
import ShopifyWelcome from "./ShopifyWelcome";
import dynamic from "next/dynamic";
import RetailerWidgetTextContentSettings from "src/components/RetailerWidgetSettings/RetailerWidgetTextContentSettings";
import RetailerWidgetConfiguration from "src/components/RetailerWidgetSettings/RetailerWidgetConfiguration/RetailerWidgetConfiguration";
import Api from "src/data/api";

const DynamicEditor = dynamic(() => import("../../Editor"), {
    ssr: false,
});

const SettingsGettingStarted = ({
    isShopify,
    widgetSettings,
    widgetToken,
    widgetImg,
    widgetTextContent,
}) => {
    const fetchEmailContents = async () => {
        let { data } = await Api.request({
            url: `/retailer/emails/settings`,
        });

        return data;
    };

    const saveEmailContents = async (data) => {
        await Api.request({
            method: "POST",
            url: `/retailer/emails/settings`,
            data,
        });
    };
    return (
        <>
            <DynamicEditor
                additionalInfo={`You can customize the confirmation email shoppers receive below. If you'd like to customize the email on a store by store basis, you can do that in the "Locations" tab.`}
                fetchEmailContents={fetchEmailContents}
                saveEmailContents={saveEmailContents}
            />

            {!isShopify && (
                <RetailerWidgetSettings
                    widgetSettings={widgetSettings}
                    widgetToken={widgetToken}
                />
            )}
            <RetailerWidgetConfiguration widgetSettings={widgetSettings} />
            <RetailerWidgetTextContentSettings
                widgetTextContent={widgetTextContent}
                widgetSettings={widgetSettings}
            />
        </>
    );
};

export default SettingsGettingStarted;
